import Styleguide, { Colors, theme } from "../theme";
import styled from "styled-components";

const Title = styled.h1`
  font-family: ${Styleguide.fonts.heading.name};
  font-size: ${Styleguide.fontSizes[22]};
  text-align: center;
  font-weight: ${Styleguide.fontWeights.semibold};
  color: ${theme(Colors.gray[500], Colors.white)};
  margin: 0;
  max-width: 312px;

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    max-width: 496px;
    font-size: ${Styleguide.fontSizes[28]};
    text-align: start;
  }
`;

export default Title;
